import { getOrderPerson } from "../../../../../shared/utils/getOrderPerson"

import { MeetingServiceOrder, MeetingServiceOrderStatus, MeetingServiceOrdersView } from "./meetingServiceTypes"

/**
 * Free-text search predicate for a meeting service order, matching on id, meeting name, delivery
 * location and the responsible person. Shared between the meeting-service table (`globalFilterFn`)
 * and the production view so both behave identically.
 */
export function meetingServiceOrderMatchesSearch(order: MeetingServiceOrder, search: string): boolean {
    if (!search) return true

    const needle = search.toLowerCase()
    const { responsible } = getOrderPerson(order.organizers)

    const id = String(order.id).toLowerCase()
    const meetingName = order.meetingDetails?.meetingName?.toLowerCase() ?? ""
    const location = order.deliveryDetails?.location?.name?.toLowerCase() ?? ""
    const responsibleName = responsible?.name?.toLowerCase() ?? ""

    return (
        id.includes(needle) ||
        meetingName.includes(needle) ||
        location.includes(needle) ||
        responsibleName.includes(needle)
    )
}

/**
 * Statuses that should NOT be offered in the status-change dropdown for a given view. Shared between
 * the meeting-service table and the production view so both expose precisely the same statuses — any
 * change here is reflected in both places.
 */
export function getHiddenOrderStatuses(view: MeetingServiceOrdersView): MeetingServiceOrderStatus[] {
    switch (view) {
        case MeetingServiceOrdersView.NOT_APPROVED:
            return [
                MeetingServiceOrderStatus.NOT_APPROVED,
                MeetingServiceOrderStatus.REJECTED,
                MeetingServiceOrderStatus.PREPARING,
                MeetingServiceOrderStatus.DELIVERED,
                MeetingServiceOrderStatus.TO_BE_BOOKED,
                MeetingServiceOrderStatus.BOOKED,
                MeetingServiceOrderStatus.READY,
                MeetingServiceOrderStatus.COMPLETED,
            ]
        case MeetingServiceOrdersView.TO_BE_BOOKED:
            return [
                MeetingServiceOrderStatus.NOT_APPROVED,
                MeetingServiceOrderStatus.APPROVED,
                MeetingServiceOrderStatus.REJECTED,
                MeetingServiceOrderStatus.DELIVERED,
                MeetingServiceOrderStatus.PREPARING,
                MeetingServiceOrderStatus.READY,
                MeetingServiceOrderStatus.COMPLETED,
            ]
        case MeetingServiceOrdersView.PRODUCTION:
            return [
                MeetingServiceOrderStatus.APPROVED,
                MeetingServiceOrderStatus.REJECTED,
                MeetingServiceOrderStatus.NOT_APPROVED,
                MeetingServiceOrderStatus.TO_BE_BOOKED,
                MeetingServiceOrderStatus.PREPARING,
                MeetingServiceOrderStatus.READY,
                MeetingServiceOrderStatus.COMPLETED,
            ]

        default:
            return []
    }
}
